import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditBlogTag from "../../components/blog-tags/FormAddEditBlogTag";

const CreateBlogTag = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/blog/tags");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditBlogTag isEdit={false} currentData={null} onSubmitSuccess={handleSuccess} />
        </WrapperSection>
    );
};

export default CreateBlogTag;
